import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <small className="Footer">
      <a
        href="https://github.com/ZBurdge/weather-app-react.git"
        alt="github-link"
        target="_blank"
        rel="noreferrer"
      >
        Open-source code
      </a>
      , by Zgene' Burdge
    </small>
  );
}
